import { Helpers, DtoKeys } from '@bode-canada/core';
import NumberHelper from '@/utils/NumberHelper';
import {
  DEFAULT_SEARCH_PAGE_SIZE,
  DEFAULT_SEARCH_SORTING,
} from '../constants';
import { GridSortType } from '@/ui-kit/components/grid/enums';

const { SearchListingFilterDtoKey, NewListingDtoKey } = DtoKeys;

export default class FilterMapper {
  static mapToDto(filter) {
    return {
      pagination: this.#getPagination(filter.pageSize),
      filters: this.#removeEmptyProperties({
        [SearchListingFilterDtoKey.LOCATION]: this.getLocation(filter),
        [SearchListingFilterDtoKey.PRICE]: this.#getRange(filter.minPrice, filter.maxPrice),
        [SearchListingFilterDtoKey.BEDS]: this.#getRange(filter.minBeds),
        [SearchListingFilterDtoKey.BATHS]: this.#getRange(filter.minBaths),
        [SearchListingFilterDtoKey.TOTAL_FINISH_SQFT]:
          this.#getRange(filter.minFinishedSqft, filter.maxFinishedSqft),
        [SearchListingFilterDtoKey.LOT_SIZE_SQFT]: this.#getRange(
          filter.minLotSizeAcres && NumberHelper.acresToSqft(filter.minLotSizeAcres),
          filter.maxLotSizeAcres && NumberHelper.acresToSqft(filter.maxLotSizeAcres),
        ),
        [SearchListingFilterDtoKey.YEAR_BUILT]:
          this.#getRange(filter.minYearBuilt, filter.maxYearBuilt),
        [SearchListingFilterDtoKey.BUILDING_CLASSES]: filter.buildingClass,
        [SearchListingFilterDtoKey.ORIGINS]: this.#removeEmptyProperties([filter.origin]),
        [SearchListingFilterDtoKey.STATUSES]:
          this.#removeEmptyProperties([filter.showBodeSales]),
        [SearchListingFilterDtoKey.SEARCH]: filter.search?.trim(),
      }),
      sorting: this.#getSorting(filter.sort),
    };
  }

  static getLocation(filter) {
    const rectangle = this.#mapDotsToRectangle(filter);

    return rectangle ? [rectangle] : null;
  }

  static #mapDotsToRectangle({
    minLat, minLon, maxLat, maxLon,
  }) {
    if (!(minLat && minLon && maxLon && minLat)) {
      return null;
    }

    return [
      [minLon, minLat],
      [minLon, maxLat],
      [maxLon, maxLat],
      [maxLon, minLat],
      [minLon, minLat],
    ];
  }

  static #removeEmptyProperties(input) {
    const result = Array.isArray(input)
      ? input.filter(((item) => item))
      : Helpers.ObjectHelper.removeEmptyProperties(input);

    return this.#checkObjectFields(result);
  }

  static #getRange(min, max) {
    return this.#removeEmptyProperties({
      min: min && Number(min),
      max: max && Number(max),
    });
  }

  static #checkObjectFields(input) {
    return Object.keys(input).length ? input : null;
  }

  static #getSorting(sort) {
    switch (sort) {
      case 'price_desc':
        return {
          orderBy: NewListingDtoKey.PRICE,
          order: GridSortType.Desc,
        };
      case 'price_asc':
        return {
          orderBy: NewListingDtoKey.PRICE,
          order: GridSortType.Asc,
        };
      case 'price_updated_at_desc': {
        return {
          orderBy: NewListingDtoKey.PRICE_UPDATED_AT,
          order: GridSortType.Desc,
        };
      }
      default:
        return DEFAULT_SEARCH_SORTING;
    }
  }

  static #getPagination(pageSize) {
    return {
      pageSize: pageSize || DEFAULT_SEARCH_PAGE_SIZE,
    };
  }
}
